import React, {Component} from 'react';
import {connect} from 'react-redux';
import FileDataReceiver from './components/file-data-receiver';
import Loader from 'components/atoms/loaders/loader';

class LateSwapFileDataReceiver extends Component {
    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isReady();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {lateswapCsvLineups} = this.props;

        if (lateswapCsvLineups.isLoadingStatusFinished()) {
            return null;
        }

        if (lateswapCsvLineups.isLoadingStatusInProgress()) {
            return <Loader />;
        }

        return (
            <div className="white-box">
                <FileDataReceiver />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        lateSwap: {csvLineups},
    } = state;

    return {
        sportConfig,
        lateswapCsvLineups: csvLineups,
    };
}

export default connect(mapStatesToProps)(LateSwapFileDataReceiver);
